// A type guard function that checks if a given value is not null or undefined.
export const nonNullable = <T>(value: T): value is NonNullable<T> => {
  return value != null;
};
